import { NgModule } from '@angular/core';

import { DetachedRouterModule } from '@recruitee/common';
import { I18nModule } from '@recruitee/i18n';

import { AccountSetupApiService } from './account-setup-api.service';

@NgModule({
  imports: [I18nModule, DetachedRouterModule],
  providers: [AccountSetupApiService],
  exports: [I18nModule, DetachedRouterModule],
})
export class AccountSetupSharedModule {}
